import type { AxiosResponse } from "axios";
import { createMutation } from "react-query-kit";

import type { IDeclineAppointmentParams } from "@api/appointment/types";
import { generatePath } from "@routes/generatePath.ts";
import { useAppointmentTable } from "@api/appointment/getAppointmentTable";
import { useShowAppointment } from "@api/appointment/showAppointment";
import { useAppointmentDetail } from "@api/appointment/getAppointmentDetail";
import type { IApiResponse, IAxiosFn } from "@/api";
import { axiosClient, queryClient } from "@/api";

type IResponse = AxiosResponse<IApiResponse<unknown>>;
type IVariables = IDeclineAppointmentParams;
export const declineAppointment: IAxiosFn<IVariables, IResponse> = (
  data,
  signal,
) => {
  return axiosClient.put(
    generatePath("/appointments/:appointment_id/decline", {
      appointment_id: data?.appointmentId,
    }),
    undefined,
    { signal },
  );
};

export const useDeclineAppointment = createMutation<IResponse, IVariables>({
  mutationFn: (data) => declineAppointment(data),
  onSuccess: (_, { appointmentId }) => {
    queryClient.invalidateQueries(useAppointmentTable.getKey());
    queryClient.invalidateQueries(useShowAppointment.getKey({ appointmentId }));
    queryClient.invalidateQueries(
      useAppointmentDetail.getKey({ id: appointmentId?.toString() }),
    );
  },
});
